'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'Which is the best Marathi Local Matrimony in Pune?', answer: 'MarathiVadhuVarSuchak.com is the best Marathi Local Matrimony for Pune based educated Marathi Vadhu Var Suchak.' },
  { question: 'Which is the trusted Marathi Local Matrimony App in Mumbai?', answer: 'MarathiVadhuVarSuchak.com is the best Marathi Local Matrimony for Mumbai based educated Marathi Vadhu Var Suchak.' },
  { question: 'How to search the Marathi Local Matrimony Photos with profiles?', answer: 'To search the Marathi Local Matrimony Photos with profiles visit MarathiVadhuVarSuchak.com for free registration.' },
  { question: 'Which is the most trusted Marathi Local Matrimony in Navi Mumbai?', answer: 'For Navi Mumbai based educated Marathi Vadhu Var, MarathiVadhuVarSuchak.com is the most trusted Marathi Local Matrimony.' },
  { question: 'Which is the trusted Marathi Local Matrimony in Thane city?', answer: 'For Thane based educated Marathi Vadhu Var, MarathiVadhuVarSuchak.com is the most trusted Marathi Local Matrimony.' },
  { question: 'Which is the best Marathi Local Matrimony in Vasai Virar city?', answer: 'For Vasai Virar based educated Marathi Vadhu Var, MarathiVadhuVarSuchak.com is the most trusted Marathi Local Matrimony.' },
  { question: 'Which is the best Marathi Local Matrimony in Pimpri city?', answer: 'For Pimpri based well educated Marathi Vadhu Var, MarathiVadhuVarSuchak.com is the most trusted Marathi Local Matrimony.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Pune Local Matrimony" },
  { label: "Pune Local Matrimony App" },
  { label: "Mumbai Local Matrimony" },
  { label: "Mumbai Local Matrimony App" },
  { label: "Mumbai Lokal Matrimony" },
  { label: "Pune Lokal Matrimony" },
  { label: "Marathi Local Matrimony" },
  { label: "Marathi Local Matrimony App" },
  { label: "Marathi Local Matrimony Photos" },
  { label: "Thane Local Matrimony" },
  { label: "Thane Local Matrimony App" },
  { label: "Navi Mumbai Local Matrimony" },
  { label: "Navi Mumbai Local Matrimony App" },
  { label: "Vasai Virar Local Matrimony" },
  { label: "Vasai Virar Local Matrimony App" },
  { label: "Kalyan Dombivli Local Matrimony" },
  { label: "Kalyan Dombivli Local Matrimony App" },
  { label: "Marathi Local Matrimony WhatsApp Group Link" },
  { label: "Marathi Local Matrimony Girl" },
  { label: "Top 10 Marathi Matrimony Sites" },
  { label: "Marathi Local Matrimony App Download" },
  { label: "Marathi Matrimony Contact Number" },
  { label: "Marathi Matrimony Girl Profile" },
  { label: "Marathi Lokal Matrimony" },
];

export default function MarathiLocalMatrimonyAppClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="प्रत्येक शहरातील सुशिक्षित मराठी वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="marathi_local_matrimony_app"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Mumbai Local Matrimony for Educated Marathi Vadhu Var"
        items={communityServices}
      />

    </div>
  );
}
